import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { isMobileTablet } from './utils';
import i18n from './i18n';
import init from "./wallet";


const root = ReactDOM.createRoot(document.getElementById('root'));

// 动态设置根字体大小
const setRootFontSize = () => {
  if(isMobileTablet()){
    const designWidth = 375;  // 设计稿基准宽度（iPhone 6/7/8）
    const baseSize = 16;      // 1rem基准值（建议与设计稿px单位直接对应）
    const currentWidth = document.documentElement.clientWidth;
    
    // 计算缩放比例（限制最大缩放倍数）
    const scale = Math.min(currentWidth / designWidth, 2); 
    document.documentElement.style.fontSize = `${baseSize * scale}px`;
  }
  else{
    document.documentElement.style.fontSize = ``;
  }
  
};



// 初始化设置
setRootFontSize();

// 初始化钱包配置
init();

// 监听窗口变化（添加防抖）
let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    setRootFontSize();
  }, 100);
});

  // 监听设备横竖屏变化


root.render(
  <React.StrictMode>
    <BrowserRouter>
      <I18nextProvider i18n={i18n}>
        <App />
      </I18nextProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
